import commonVars from './common.module.scss';

export const gradientPalette = [
    {
        name: 'Gradient 01',
        slug: 'gradient01',
        gradient: commonVars.gradient01
    }
]